import React, { useCallback, useState } from 'react';

import { If } from 'utils';
import { UiKit } from 'components';
import { CUSTOM_WINDOW, SERVICEABLE_DAYS_OPTIONS } from './stubs';

/**
 * @param {object} props
 * @param {import('utils/types').Size} props.chipSize
 * @param {string} props.label
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {boolean} props.isProcessing
 * @param {string} props.error
 */
export default function ServiceableDays({
  chipSize = 'md',
  label = '',
  value = '',
  initialValue = '',
  onChange = () => {},
  isProcessing = false,
  error = ''
}) {
  const [selected, setSelected] = useState(() => {
    const exists = SERVICEABLE_DAYS_OPTIONS.some(
      option => +option.value === +value
    );
    return exists ? value : CUSTOM_WINDOW;
  });

  const onSelect = useCallback(
    value => {
      setSelected(value);
      onChange(value !== CUSTOM_WINDOW ? value : initialValue);
    },
    [onChange, initialValue]
  );

  const options = SERVICEABLE_DAYS_OPTIONS.map(option => {
    return (
      <UiKit.Chip
        key={option.value}
        size={chipSize}
        isSelected={selected === option.value}
        onClick={() => onSelect(option.value)}
        isDisabled={isProcessing}
      >
        <UiKit.Text variant={isProcessing ? 400 : 800} weight="bold">
          {option.label}
        </UiKit.Text>
      </UiKit.Chip>
    );
  });

  return (
    <UiKit.Flex direction="column" gap={16}>
      <UiKit.Flex direction="column" gap={8}>
        <UiKit.Title size="sm" weight="bold">
          {label}
        </UiKit.Title>
        <UiKit.Grid gap={16}>{options}</UiKit.Grid>
      </UiKit.Flex>
      <If test={selected === CUSTOM_WINDOW}>
        <UiKit.Input
          autoFocus
          type="number"
          min={1}
          label={
            <>
              Return Window&nbsp;
              <span style={{ color: '#9CA3AF', fontSize: 12 }}>(in days)</span>
            </>
          }
          value={value}
          onChange={onChange}
          placeholder="Enter custom return window"
          disabled={isProcessing}
          error={error}
        />
      </If>
    </UiKit.Flex>
  );
}
